
/// app js

import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";


import "./App.css"
const API = "https://back.gershona.com";
// const API = "http://localhost:3001";
const ABC = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
const ABCHE = "אבגדהוזחטיכלמנסעפצקרשתךםן".split("");




function LoaderABC({ text = "Loading your lesson..." }) {
  const letters = ["A", "B", "C"];

  return (
    <div className="flex flex-col items-center justify-center gap-4 mt-4">
      <div className="flex gap-2 text-2xl font-bold">
        {letters.map((letter, idx) => (
          <span
            key={letter}
            className="text-gray-400 animate-bounce"
            style={{ animationDelay: `${idx * 0.2}s` }}
          >
            {letter}
          </span>
        ))}
      </div>
      <p className="text-gray-600 font-mono text-sm animate-pulse">{text}</p>
    </div>
  );
}

// ---------------- FETCH WITH RETRY ----------------
async function fetchWithRetry(
  url,
  options = {},
  {
    retries = 3,
    delay = 800,
    backoff = 1.5,
  } = {}
) {
  try {
    const res = await fetch(url, options);

    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }

    return res;
  } catch (err) {
    if (retries <= 0) {
      throw err;
    }

    await new Promise(resolve => setTimeout(resolve, delay));

    return fetchWithRetry(url, options, {
      retries: retries - 1,
      delay: delay * backoff,
      backoff,
    });
  }
}


// ---------------- USER ID ----------------
function getUserId() {
  let userId = localStorage.getItem("userId");
  if (!userId) {
    userId = crypto.randomUUID();
    localStorage.setItem("userId", userId);
  }
  return userId;
}
const userId = getUserId();
// const defaultlang = 'en';


function stopSpeak() {
  if ("speechSynthesis" in window) {
    speechSynthesis.cancel();
  }
}


// ---------------- SPEAK CORE ---------------f-
function speak(text, lang = "en-US") {
  if (!("speechSynthesis" in window)) return;
  if (!text) return;

  speechSynthesis.cancel();

  let cleanText = text;

  if (lang.startsWith("en")) {
    cleanText = text.replace(/[^a-zA-Z0-9\s]/g, "");
    if (!cleanText) return;
  }

  if (lang.startsWith("he")) {
    // cleanText = text.replace(/[^a-zA-Z0-9\s]/g, "");
    // // alert(cleanText);
    // if (!cleanText) return;
  }

  const utterance = new SpeechSynthesisUtterance(cleanText);
  utterance.lang = lang;

  const voices = window.speechSynthesis.getVoices();
  const voice = voices.find(v => v.lang.startsWith(lang.split("-")[0]));

  if (voice) utterance.voice = voice;

  utterance.rate = 0.9;
  utterance.pitch = 1;



  speechSynthesis.speak(utterance);
}

// ---------------- SMART SOUND (PHONICS) ----------------
function speakSoundAware(text, lang = "en-US") {
  if (!text) return;

  const isPhonics =
    lang.startsWith("en") &&
    (
      text.length <= 3 ||
      /^[a-z]{1,3}$/i.test(text) ||
      ["ch", "sh", "th", "oo", "ing"].includes(text.toLowerCase())
    );

  if (isPhonics) {
    // speak(${text} sound, lang);
  } else {
    // speak(text, lang);
  }

  speak(text, lang);

}


// when i will move it into   a comppent i will use hook here to the lang and fallnack lang...
// ---------------- ABC SCREEN ----------------
function LearnABCScreen({ setScreen }) {

  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const fallbackLanguage = i18n.options.fallbackLng;

  const arr = currentLanguage == 'en' ? ABC : ABCHE




  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 text-center">
      <h1 className="text-3xl font-bold">🔤 {t("Learn ABC")}</h1>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4 mt-4">
  {arr.map(letter => (
    <button
      key={letter}
      onClick={(e) => {
        const textToSpeak = Array.from(
          e.currentTarget.querySelectorAll("span")
        )
          .filter(el => !el.hasAttribute("data-ignore-speak"))
          .map(el => el.textContent)
          .join(" ");

        const langToSend = currentLanguage == fallbackLanguage ? 'en-US' : 'he-IL';
        speakSoundAware(textToSpeak, langToSend);
      }}
      className="w-full aspect-square px-4 py-4 text-2xl font-bold rounded-xl shadow bg-blue-500 text-white flex flex-col items-center justify-center"
    >
      <span className="text-3xl">{letter}</span>

      {currentLanguage == fallbackLanguage && (
        <span className="text-xl mt-1" data-ignore-speak>
          {letter.toLowerCase()}
        </span>
      )}
    </button>
  ))}
</div>


      <button
        onClick={() => setScreen("home")}
        className="mt-6 px-6 py-3 rounded-xl bg-gray-300"
      >
        ⬅ {t('Back Home')}
      </button>
    </div>
  );
}


const Main = ({ children, hideLanguageSwicher = false }) => {

  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const fallbackLanguage = i18n.options.fallbackLng;

  // alert(fallbackLanguage);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <main className={'app-lang app-lang-' + currentLanguage}>
      <img src="./img.png" alt="" className="app-img-1"></img>
      {
        hideLanguageSwicher === false
          ? <div className="app-flags">
            <button onClick={() => {
              changeLanguage("en")
            }}>
              <svg xmlns="http://www.w3.org/2000/svg" id="flag-icons-us" viewBox="0 0 640 480">
                <path fill="#bd3d44" d="M0 0h640v480H0" />
                <path stroke="#fff" strokeWidth="37" d="M0 55.3h640M0 129h640M0 203h640M0 277h640M0 351h640M0 425h640" />
                <path fill="#192f5d" d="M0 0h364.8v258.5H0" />
                <marker id="us-a" markerHeight="30" markerWidth="30">
                  <path fill="#fff" d="m14 0 9 27L0 10h28L5 27z" />
                </marker>
                <path fill="none" markerMid="url(#us-a)" d="m0 0 16 11h61 61 61 61 60L47 37h61 61 60 61L16 63h61 61 61 61 60L47 89h61 61 60 61L16 115h61 61 61 61 60L47 141h61 61 60 61L16 166h61 61 61 61 60L47 192h61 61 60 61L16 218h61 61 61 61 60z" />
              </svg>
            </button>

            <button onClick={() => {
              changeLanguage("he")
            }}>
              <svg xmlns="http://www.w3.org/2000/svg" id="flag-icons-il" viewBox="0 0 640 480">
                <defs>
                  <clipPath id="il-a">
                    <path fillOpacity=".7" d="M-87.6 0H595v512H-87.6z" />
                  </clipPath>
                </defs>
                <g fillRule="evenodd" clipPath="url(#il-a)" transform="translate(82.1)scale(.94)">
                  <path fill="#fff" d="M619.4 512H-112V0h731.4z" />
                  <path fill="#0038b8" d="M619.4 115.2H-112V48h731.4zm0 350.5H-112v-67.2h731.4zm-483-275 110.1 191.6L359 191.6z" />
                  <path fill="#fff" d="m225.8 317.8 20.9 35.5 21.4-35.3z" />
                  <path fill="#0038b8" d="M136 320.6 246.2 129l112.4 190.8z" />
                  <path fill="#fff" d="m225.8 191.6 20.9-35.5 21.4 35.4zM182 271.1l-21.7 36 41-.1-19.3-36zm-21.3-66.5 41.2.3-19.8 36.3zm151.2 67 20.9 35.5-41.7-.5zm20.5-67-41.2.3 19.8 36.3zm-114.3 0L189.7 256l28.8 50.3 52.8 1.2 32-51.5-29.6-52z" />
                </g>
              </svg>
            </button>
          </div>
          : null
      }

      <div className="content">{children}</div>
    </main>
  )
}
// ---------------- MAIN APP ----------------
export default function App() {



  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const fallbackLanguage = i18n.options.fallbackLng;
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const [username, setUsername] = useState(localStorage.getItem("username") || null);

  const [isSpeaking, setIsSpeaking] = useState(false);
  const [speakingType, setSpeakingType] = useState(null);

  const [screen, setScreen] = useState("home");
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState(null);
  const [question, setQuestion] = useState("");
  const [options, setOptions] = useState([]);
  const [hint, setHint] = useState("");
  const [feedback, setFeedback] = useState("");
  const [score, setScore] = useState(0);
  const [step, setStep] = useState(0);
  const [total, setTotal] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [aiRating, setAiRating] = useState(null);
  const [loading, setLoading] = useState(false);

  const [review, setReview] = useState(null);


  const firstOptionRef = useRef(null);

  useEffect(() => {
    fetchWithRetry(`${API}/api/categories?lang=${currentLanguage}`)
      .then(res => res.json())
      .then(data => setCategories(data.categories));
  }, [currentLanguage]);

  useEffect(() => {
    if (firstOptionRef.current) firstOptionRef.current.focus();
    if (question) {
      // alert("S");

      console.log("currentLanguage", currentLanguage);
      const langToSend = currentLanguage == fallbackLanguage ? 'en-US' : 'he-IL';
      console.log("langToSend", langToSend);

      // speakSoundAware(question , langToSend);
    }
  }, [question]);

  // ---------------- START LESSON ----------------
  const startLesson = async (selectedCategory) => {
    setLoading(true);
    setFeedback("");
    setSelectedOption(null);
    speechSynthesis.cancel(); // עוצר הקראה אם יש

    try {
      const res = await fetchWithRetry(`${API}/api/start`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          category: selectedCategory,
          userId,
          lang: currentLanguage,
        }),
      });

      const data = await res.json();

      setCategory(selectedCategory);
      setQuestion(data.question);
      setOptions(data.options);
      setHint(data.hint || "");
      setScore(data.score);
      setStep(data.step);
      setTotal(data.total);

      setScreen("lesson"); // 🔥 עובר מסך רק אחרי שיש נתונים
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };


  // ---------------- LOGIN SCREEN ----------------



  // ---------------- SUBMIT ----------------
  const handleSubmit = async () => {
    if (!selectedOption) return;
    setLoading(true);

    const res = await fetchWithRetry(`${API}/api/answer`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ answer: selectedOption, userId, lang: currentLanguage })
    });

    const data = await res.json();
    setFeedback(data.feedback);


    const langToSend = currentLanguage == fallbackLanguage ? 'en-US' : 'he-IL';

    // alert(langToSend);
    speakSoundAware(data.feedback, langToSend);
    // speakSoundAware(data.feedback);

    // if (data.finished) {
    //   setScore(data.score);
    //   setAiRating(data.aiRating);
    //   setTimeout(() => setScreen("summary"), 1500);
    //   return;
    // }

    if (data.finished) {
      setScore(data.score);
      setReview(data.review);

      // הקראת סיכום קצר
      if (data.review?.rating) {
        const langToSend = currentLanguage == fallbackLanguage ? "en-US" : "he-IL";
        speakSoundAware(data.review.rating, langToSend);
      }

      setTimeout(() => setScreen("summary"), 1200);
      return;
    }

    setTimeout(() => {
      setQuestion(data.question);
      setOptions(data.options);
      setHint(data.hint || "");
      setScore(data.score);
      setStep(data.step);
      setSelectedOption(null);
      setFeedback("");
      setLoading(false);
    }, 1500);
  };

  // if (!username) return <LoginScreen onLogin={setUsername} />;

  // ---------------- SCREENS ----------------
  if (screen === 'home') {
    return (
      <Main >
        <div className='min-h-screen flex flex-col items-center justify-center gap-6 text-center'>
          {
            loading == true
              ? <LoaderABC />
              : <>
                <h1 className='text-3xl font-bold'> {t('title')} </h1>
                <p className='text-lg'>{t('Choose a category:')}</p>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">

                  {
                    categories.map(cat => (
                      <button
                        key={cat.id}
                        onClick={() => startLesson(cat.id)}
                        className="px-6 py-4 text-xl rounded-2xl shadow bg-blue-500 text-white"
                      >
                        {cat.label}
                      </button>
                    ))
                  }

                  <button
                    onClick={() => setScreen('abc')}
                    className="px-6 py-4 text-xl rounded-2xl shadow bg-green-500 text-white"
                  >
                    {t("Learn ABC")}
                  </button>
                  </div>
                </>
                
          }

              
        </div>
      </Main>
    );
  }

  if (screen === "abc") return <Main ><LearnABCScreen lang={currentLanguage} setScreen={setScreen} /></Main>

  if (screen === "lesson") {
    return (




      <Main hideLanguageSwicher={true}>
        <div className="min-h-screen flex flex-col items-center justify-center gap-4 text-center px-4">

          {
            loading == true
              ? null
              : <>

                <h1 className="text-2xl font-bold">{category}</h1>
                <div>Question {step} / {total}</div>
                <div className="text-xl flex gap-2 justify-center w-80 w-fix-width">
                  {question}
                  <button
                    onClick={() => {
                      const langToSend =
                        currentLanguage == fallbackLanguage ? "en-US" : "he-IL";

                      if (speechSynthesis.speaking) {
                        stopSpeak();
                        setIsSpeaking(false);
                      } else {
                        speakSoundAware(question, langToSend);
                        setIsSpeaking(true);
                      }
                    }}
                  >
                    {speechSynthesis.speaking ? "⏹" : "🔊"}
                  </button>

                </div>

                {hint && (
                  <div className="text-gray-600 flex gap-2 items-center">
                    {hint}

                    <button
                      onClick={() => {
                        const langToSend =
                          currentLanguage == fallbackLanguage ? "en-US" : "he-IL";

                        if (speechSynthesis.speaking && speakingType === "hint") {
                          stopSpeak();
                          setSpeakingType(null);
                        } else {
                          stopSpeak(); // עוצר כל דבר אחר קודם
                          speakSoundAware(hint, langToSend);
                          setSpeakingType("hint");
                        }
                      }}
                    >
                      {speechSynthesis.speaking && speakingType === "hint"
                        ? "⏹"
                        : "🔊"}
                    </button>
                  </div>
                )}


              </>
          }



          {loading ? (
            <LoaderABC />
          ) : (
            options.map((opt, i) => (
              <button
                key={opt}
                ref={i === 0 ? firstOptionRef : null}
                onClick={() => {
                  // speakSoundAware(opt);
                  // const langToSend = currentLanguage == fallbackLanguage ? 'en-US' : 'he-IL';
                  // speakSoundAware(opt, langToSend);
                  setSelectedOption(opt);
                }}
                className={`w-full max-w-md px-5 py-3 rounded-2xl border ${selectedOption === opt ? "bg-black text-white" : ""
                  }`}
              >
                {opt}

                <span onClick={() => {
                  const langToSend = currentLanguage == fallbackLanguage ? 'en-US' : 'he-IL';
                  speakSoundAware(opt, langToSend);
                }}>🔊</span>
              </button>
            ))
          )}

          <button
            onClick={handleSubmit}
            className="px-6 py-3 rounded-xl bg-blue-600 text-white"
          >
            {t('Submit')}
          </button>

          <button onClick={() => setScreen('home')} className='px-6 py-3 rounded-xl bg-white-600 text-black'>⬅ {t('Previous')}</button>

          {feedback && <div className="text-green-600">{feedback}</div>}

          {
            parseInt(score) > 0 
            ? <div>⭐ {t('Score')}: {score}</div>
            : null
          }
          



        </div>
      </Main>



    );
  }

  // if (screen === "summary") {
  //   return (
  //     <Main >
  //       <div className="min-h-screen flex flex-col items-center justify-center gap-4 text-center">
  //         <h1 className="text-3xl font-bold">🎉 {t('Great Job!')}</h1>
  //         <div>{t('Final Score')}: ⭐ {score}</div>

  //         {aiRating && (
  //           <div className="bg-sky-100 p-4">
  //             <p><strong>{aiRating.rating}</strong></p>
  //             <p>{aiRating.recommendation}</p>
  //           </div>
  //         )}

  //         <button onClick={() => setScreen("home")} className="px-6 py-3 bg-gray-300 rounded-xl">
  //           ⬅ {t('Back Home')}
  //         </button>
  //       </div>
  //     </Main>
  //   );
  // }


  if (screen === "summary") {
    return (
      <Main>
        <div className="min-h-screen flex flex-col items-center justify-center gap-6 text-center px-4">

          <h1 className="text-3xl font-bold">🎉 {t("Great Job!")}</h1>
          <div>{t("Final Score")}: ⭐ {score}</div>

          {review && (
            <>
              <div className="bg-sky-100 p-4 rounded-xl max-w-xl w-full">
                <p className="text-xl font-bold">{review.rating}</p>
                <p className="mt-2">{review.recommendation}</p>
              </div>

              <div className="max-w-xl w-full text-left mt-4 space-y-3">
                {review.questions.map((q, idx) => (
                  <div
                    key={idx}
                    className={`p-3 rounded-xl border ${q.isCorrect ? "bg-green-50" : "bg-red-50"
                      }`}
                  >
                    <p className="font-bold">
                      {idx + 1}. {q.question}
                    </p>

                    <p>
                      ✅ {t("Your Answer")}:{" "}
                      <strong>{q.userAnswer}</strong>
                    </p>

                    {!q.isCorrect && (
                      <>
                        <p>
                          ❌ {t("Correct Answer")}:{" "}
                          <strong>{q.correctAnswer}</strong>
                        </p>
                        <p className="text-sm mt-1">
                          💡 {q.explanation}
                          <button
                            className="ml-2"
                            onClick={() => {
                              const langToSend =
                                currentLanguage == fallbackLanguage
                                  ? "en-US"
                                  : "he-IL";
                              speakSoundAware(q.explanation, langToSend);
                            }}
                          >
                            🔊
                          </button>
                        </p>
                      </>
                    )}
                  </div>
                ))}
              </div>
            </>
          )}

          <button
            onClick={() => {
              setReview(null);
              setScreen("home");
            }}
            className="px-6 py-3 bg-gray-300 rounded-xl"
          >
            ⬅ {t("Back Home")}
          </button>
        </div>
      </Main>
    );
  }



  return null;
}


